import React, { useState } from 'react'
import styled from 'styled-components'
import { LibraryImport, LibraryImportBookResult, LibraryImportStatus } from '../../../../../data/profile/data-types'
import { formatDate } from '../../../../../utilities/date'

type SingleImportProps = {
  library_import: LibraryImport
}

const SingleImport: React.FunctionComponent<SingleImportProps> = ({ library_import }) => {
  const [open, setOpen] = useState(false)

  const import_status = library_import.status

  return (
    <Container>
        <Line onClick={() => import_status !== LibraryImportStatus.pending && setOpen(!open) }>
            <Source>Goodreads</Source>
            <Status status={import_status}>
                {getStatusText(import_status)}
            </Status>
            <DateInitiated>
                {formatDate(new Date(library_import.creation_date))}
            </DateInitiated>
        </Line>
        { 
            <Details open={open}>
                {
                    import_status === LibraryImportStatus.error 
                        ? <DetailsTableItem>
                            <Icon src={require('./images/error.svg')} />
                            <Error>
                                {library_import.errors.error}
                            </Error>
                        </DetailsTableItem>
                        : null
                }

                {
                   import_status === LibraryImportStatus.partial
                    ? <PartialDetais>
                        <DetailsTableHeader>Book Name</DetailsTableHeader>
                        <DetailsTableHeader>Reason not imported</DetailsTableHeader>
                        {Object.keys(library_import.errors).map(title => (
                            <>
                                <DetailsTableItem>
                                        {title}
                                </DetailsTableItem>
                                <DetailsTableItem>
                                    <Icon src={require('./images/error.svg')} />
                                    <Error>
                                        {
                                            typeof library_import.errors[title] === "string"
                                                ? library_import.errors[title]
                                                : (library_import.errors[title] as LibraryImportBookResult).error
                                        }
                                    </Error>
                                </DetailsTableItem>
                            </>
                        ))}
                    </PartialDetais>
                    : null 
                }
            </Details>
        }
    </Container>
  )
}

const getStatusText = (s: string) => s //String(s[0]).toUpperCase() + String(s).slice(1)


const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;

    width: 100%;
    
    background: ${p => p.theme.colors.bg};
    border-radius: 10px;
    
    transition: height 0.5s;
`

const Details = styled.div<{ open: boolean}>`
    display: ${p => p.open ? 'grid' : 'none'};

    align-items: center;
    justify-items: start;

    padding: 20px 40px;
`

const PartialDetais = styled.div`
    display: grid;

    align-items: center;
    justify-items: start;

    grid-gap: 10px;
    grid-template-columns: 1fr 1fr;

    width: 100%;
`

const DetailsTableHeader = styled.div`
    font-weight: bold;
    color: ${p => p.theme.colors.accent};
`

const DetailsTableItem = styled.div`
    display: flex;
    align-items: center;
`

const Error = styled.div`
    margin-left: 10px;
    font-style: italic;
    color: red;
`

const Line = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;

    width: 100%;
    padding: 20px 40px;

    border-radius: 10px;
    border: 1px solid #A2ABBA;

    cursor: pointer;
`

const Source = styled.div`
    
`

const chooseColor = (p: any) => {
    switch(p.status) {
        case LibraryImportStatus.error:
            return "red"
        case LibraryImportStatus.success:
            return p.theme.statuses[3]
        case LibraryImportStatus.pending:
            return p.theme.statuses[2]
        case LibraryImportStatus.partial:
            return p.theme.statuses[1]
        default:
            return p.theme.colors.serviceGray;
    }
}

const Status = styled.div<{ status: LibraryImportStatus}>`
    position: relative;

    display: grid;

    align-self: center;
    justify-self: center;

    padding: 5px;

    border: 2px solid ${p => chooseColor(p)};
    border-radius: 5px;

    z-index: 10;

    &:before {
        position: absolute;
        content: "";

        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        background: ${p => chooseColor(p)};

        z-index: -1;
        opacity: .4;
    }
`

const DateInitiated = styled.div`
    justify-self: end;
`

const Icon = styled.img`
    width: 30px;
    height: 30px;
`

export default SingleImport